import __request__ from "routing/request";
export function findInstances(page = 1, per_page = 50, query, filters, sort = "last_seen", order = "desc", requestOptions) {
  return __request__("GET", "/collectors", null, { "page": page, "per_page": per_page, "query": query, "filters": filters, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function reassignInstances(JSONbody, requestOptions) {
  return __request__("POST", "/collectors/instances/reassign", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteInstance(instanceUid, requestOptions) {
  return __request__("DELETE", `/collectors/instances/${instanceUid}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function stats(requestOptions) {
  return __request__("GET", "/collectors/stats", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
